import * as React from "react";
import { Link } from "react-router-dom";

type Props = {
  backofficeUrl: string;
  children?: any;
};

const backOfficeLink = (props: Props) => (
  <Link className="blueLink" to={props.backofficeUrl}>
    {props.children}
  </Link>
);

export default backOfficeLink;
